import { BadgeColorList, ColumnWidthType, DropdownItemType } from 'components'
import { CustomerType, LeadActivityType } from 'types/global'

export const Activities: { [key in LeadActivityType]: string | string[] } = {
  'Lead Lifecycle Event': ['far', 'user-chart'],
  Appointment: ['far', 'user-chart'],
  Call: ['far', 'phone'],
  Email: ['far', 'envelope'],
  'Email (Log)': ['far', 'envelope-circle-check'],
  Meeting: ['far', 'user-chart'],
  Note: ['far', 'sticky-note'],
  'Live Call': ['far', 'phone'],
  'To Do': ['far', 'list'],
  Message: ['far', 'messages'],
}

export const CustomColumnWidths: ColumnWidthType = {
  leadName: 80,
  leadOwner: 80,
  marketPotential: 80,
  priority: 80,
  leadCampaign: 80,
  leadType: 80,
}

export const ColumnTogglerDictionary: Record<string, string> = {
  leadName: 'lead_information_lbl',
  leadType: 'type_lbl',
  priority: 'priority_lbl',
  status: 'status_lbl',
  leadInDate: 'lead_in_date_lbl',
  leadCampaign: 'campaign_source_lbl',
  leadOwner: 'lead_owner_lbl',
  additionalOwner: 'collaborators_lbl',
  lastActivity: 'last_activity_lbl',
  lastActivityOutcome: 'last_activity_outcome',
  registrationNumber: 'reg_no_lbl',
  convertedBy: 'converted_by_lbl',
  convertedDate: 'converted_date_lbl',
  closedDate: 'closed_date_lbl',
  closedReason: 'closed_reason_lbl',
  closedReasonDetails: 'closed_reason_details_lbl',
  closedBy: 'closed_by_lbl',
  recycledDateAndValue: 'last_recycled_date_lbl',
  nextActivityDate: 'next_activity_date_lbl',
  totalMarketPotential: 'market_potential_title_lbl',
  deletedDate: 'deleted_date_lbl',
  deletedReason: 'deleted_reason_lbl',
  deletedBy: 'deleted_by_lbl',
  totalCalls: 'total_calls_lbl',
}

export const LeadSorterFieldMapper = {
  leadName: 'lead_name',
  leadType: 'lead_type_name',
  priority: 'lead_priority_id',
  status: 'lead_status_name',
  leadInDate: 'lead_in_date',
  leadCampaign: 'lead_campaign_name',
  leadOwner: 'lead_owner_name',
  additionalOwner: 'additional_owner_name',
  lastActivity: 'last_activity_ts',
  lastActivityOutcome: 'last_activity_outcome',
  registrationNumber: 'company_reg_no',
  convertedDate: 'converted_ts',
  closedDate: 'closed_ts',
  convertedBy: 'converted_by',
  closedReason: 'close_reason',
  closedReasonDetails: 'closed_reason_details',
  closedBy: 'closed_by',
  recycledDateAndValue: 'last_recycle_ts',
  nextActivityDate: 'next_activity_ts',
  totalMarketPotential: 'market_potential',
  deletedDate: 'delete_ts',
  deletedReason: 'deleted_reason',
  deletedBy: 'deleted_by_name',
  totalCalls: 'total_calls',
}

export const LeadRequiredFieldMapper: Record<string, string> = {
  leadName: 'lead_id, lead_name, company_name, industry_name, lead_address',
  leadType: 'lead_type_name',
  priority: 'lead_priority_name',
  status: 'lead_status_name',
  leadInDate: 'lead_in_date',
  leadCampaign: 'lead_campaign_name, lead_source_name, lead_source_type_name',
  leadSource: 'lead_source_name',
  leadOwner: 'lead_owner_name, lead_owner_team_name',
  collaborators: 'additional_owner_name, additional_owner_names, other_additional_owner_count',
  lastActivity: 'last_activity_ts, last_activity_type',
  lastActivityOutcome: 'last_activity_outcome',
  registrationNumber: 'company_reg_no',
  convertedDate: 'converted_ts',
  closedDate: 'closed_ts',
  convertedBy: 'converted_by',
  closedReason: 'close_reason',
  closedBy: 'closed_by, closed_by_name',
  recycledDateAndValue: 'is_recycle, last_recycle_ts',
  nextActivityDate: 'next_activity_ts, next_activity_type',
  totalMarketPotential: 'total_market_potential',
  closedReasonDetails: 'closed_reason_details',
  deletedDate: 'delete_ts',
  deletedReason: 'deleted_reason',
  deletedBy: 'deleted_by, deleted_by_name',
  isDeleted: 'is_deleted',
  totalCalls: 'total_calls',
}

export const LEAD_ACTIVITY_TYPE: { [key in string]: LeadActivityType } = {
  LeadLifecycleEvent: 'Lead Lifecycle Event',
  APPOINTMENT: 'Appointment',
  NOTE: 'Note',
  CALL: 'Call',
  LIVE_CALL: 'Live Call',
  EMAIL: 'Email',
  EMAIL_LOG: 'Email (Log)',
  MEETING: 'Meeting',
  TO_DO: 'To Do',
  MESSAGE: 'Message',
}

export const LeadTypeColors: { [key in CustomerType]: BadgeColorList } = {
  Corporate: 'purple',
  Individual: 'yellow',
}

export const MERGE_LEADS_REQ = 2

export const EMAIL_ORIGIN = {
  log: 'log',
  composer: 'composer',
  quotation: 'quotation',
  meetingMinutes: 'meeting_minutes',
} as const

export const PREVIOUS_LEAD_SOURCE: DropdownItemType<string> = {
  label: 'previous_lead_source_lbl',
  value: 'previous_lead_source',
}

export const PREVIOUS_LEAD_CAMPAIGN: DropdownItemType<string> = {
  label: 'previous_lead_campaign_lbl',
  value: 'previous_lead_campaign',
}

export const PREVIOUS_LEAD_PIPELINE: DropdownItemType<string> = {
  label: 'previous_sales_pipeline_lbl',
  value: 'previous_sales_pipeline',
}

export const NO_TEAM = 'no_team'
export const NO_TEAM_LBL = '(No Team)'

export const LEAD_DETAILS_VERSION_KEY = 'lead_details_version'
export const LEAD_DETAILS_VERSION_UPDATE = 'lead_details_version_update'
